// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"57fd3790","560":"7eaf7929","652":"280aac3c","939":"e15659a5"}[chunkId] + ".chunk.js";
};